export interface FieldData {
    code: string;
    value: string;
}
